<template>
  <div id="content">
    <link rel="stylesheet" href="/themes/ito/css/exchange-gift.css">

    <div class="container">
      <div id="page-header">
        <ul class="breadcrumb">
          <li class="icon">
            <router-link :to="{ name: 'home' }">
              <img src="/themes/ito/images/icon-profile.svg" alt="">
            </router-link>
          </li>
          <!-- <li>
            <router-link :to="{ name: 'exchange_gift' }">
              Exchange gift
            </router-link>
          </li>
          <li class="separator"><i class="ito-icon-breadcrumb-1"></i></li>
          <li>
            <router-link :to="{ name: 'buy_sticker' }">
              Buy Sticker
            </router-link>
          </li> -->
          <li class="separator"><i class="ito-icon-breadcrumb-1"></i></li>
          <li class="active">{{$t("collection")}}</li>
        </ul>
      </div>

      <div class="card card-exchange-gift">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{$t('buy_sticker')}}</span>
          </h5>

          <div class="card-content">
            <div>
              <ul class="nav nav-tabs" role="tablist">
                <li role="presentation">
                  <a href="#home" class="active" aria-controls="home" role="tab" data-toggle="tab">{{$t('home')}}</a>
                </li>
                <li role="presentation">
                  <a href="#profile" aria-controls="profile" role="tab" data-toggle="tab">{{$t('profile')}}</a>
                </li>
                <li role="presentation">
                  <a href="#messages" aria-controls="messages" role="tab"
                     data-toggle="tab">{{$t('messages')}}</a>
                </li>
                <li role="presentation">
                  <a href="#settings" aria-controls="settings" role="tab"
                     data-toggle="tab">{{$t('settings')}}</a>
                </li>
              </ul>

              <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                  <div class="sticker-list row">
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                    <div class="col-md-2 sticker-item">
                      <div class="thumb">
                        <div class="thumb-content">
                          <img src="/themes/ito/images/sticker.png" alt="">

                          <div class="total">02</div>
                        </div>
                      </div>
                      <div class="title">{{$t('lisa_web_Scientist_CHERY')}}</div>
                      <div class="gem">
                        100 <i class="ito-icon-gem"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div role="tabpanel" class="tab-pane" id="profile">...</div>
                <div role="tabpanel" class="tab-pane" id="messages">...</div>
                <div role="tabpanel" class="tab-pane" id="settings">...</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import {pushQueries} from '../../utils/utils'
import {mapGetters} from 'vuex'
import {getInboxs, readInbox} from "../../models/inbox";
import {claimDailyBonus} from "../../models/reward";

export default {
  name: "ExchangeCollection",
  title: 'Exchanger collection',

  data() {
    return {
      inboxes: [],
      isLoading: true
    };
  },

  created() {
    //this.$store.commit('setMenuActive', 'inbox');

    this.fetch();
  },

  methods: {
    async fetch(page = 1) {
      const that = this;

      this.page = page;

      const params = {
        page: this.page,
      };

      //pushQueries(this.$router, '/inbox', params);

      await axios.all([
        getInboxs(params),
      ]).then(axios.spread((inbox_response) => {
        that.isLoading = false;

        //that.$store.commit("setLoading", false);

        if (inbox_response.data.code != 0) {
          return;
        }

        that.inboxes = inbox_response.data.results.mails || [];
      }));
    },

  }
}
</script>

<style scoped>

</style>
